import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedFrequencyForm = (props) => {
    const initialFormData = {
        frequency: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);

    useEffect(() => {
        const val = props.medfreqvalue;
        if (val && (val.frequency_id || val.freq_id || val.id)) {
            const { frequency, name, is_active, frequency_id, freq_id, id } = val;
            setFormData({
                frequency: frequency || name || "",
                isactive: is_active == 1 || is_active === '1' || is_active === true,
                id: frequency_id || freq_id || id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.medfreqvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsMedFreqUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/prescriptions/add-prescription-frequency/` : `${process.env.REACT_APP_SERVER_URL}/prescriptions/update-prescription-frequency/`;
        let pelmedsMedFreqData = isAddMode ? 
            { "name": formData.frequency, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "name": formData.frequency, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsMedFreqUrl, pelmedsMedFreqData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success(isAddMode ? "MedFrequency added successfully" : "MedFrequency updated successfully");
        }
        else {
            toast.info("Error while adding/updating MedFrequency");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Frequency Name</Form.Label>
                        <Form.Control
                            placeholder='Frequency Name'
                            value={formData.frequency}
                            name="frequency"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            size="sm"
                            className="mt-4 w-50"
                            disabled={!formData.frequency}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};
export default MedFrequencyForm;
